import { z } from 'zod';
import { optionalUuidString, requiredUuidString } from '../zod-helpers/index.js';
import { PRODUCT_TREE_CONSTRAINTS } from './constraints.js';
export const createProductTreeInputSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, `${PRODUCT_TREE_CONSTRAINTS.name.label} is required`)
        .max(PRODUCT_TREE_CONSTRAINTS.name.maxLength, `${PRODUCT_TREE_CONSTRAINTS.name.label} must be ${PRODUCT_TREE_CONSTRAINTS.name.maxLength} characters or fewer`),
    description: z
        .string()
        .trim()
        .max(PRODUCT_TREE_CONSTRAINTS.description.maxLength, `${PRODUCT_TREE_CONSTRAINTS.description.label} must be ${PRODUCT_TREE_CONSTRAINTS.description.maxLength} characters or fewer`)
        .optional()
        .nullable(),
    // Required on create -- a category with no brand can't be governed by brand-scoped RBAC (the
    // column itself stays nullable in the DB for migrated legacy rows). See gap #8 in the NUDOOL-27
    // implementation plan.
    brandId: requiredUuidString('Brand is required.', 'Invalid brand selection.'),
    parentId: optionalUuidString('Invalid parent category selection.').nullish(),
});
//# sourceMappingURL=create-input.js.map